var _rect, _rect2, _rect3, _path, _rect4, _rect5, _rect6, _path2, _circle, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProfileCvIco = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 47,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 12.706,
  height: 33.176,
  x: 35.294,
  y: 13.059,
  fill: "#DDD",
  rx: 4
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 12.706,
  height: 39.529,
  x: 28.941,
  y: 6.706,
  fill: "#B9B9B9",
  rx: 4
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 35.294,
  height: 46.235,
  fill: "#FFE040",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F3A900",
  d: "M0 3.176A3.176 3.176 0 0 1 3.176 0h28.942a3.176 3.176 0 0 1 3.176 3.176z"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 15.529,
  height: 2.118,
  x: 12.352,
  y: 24.706,
  fill: "#656565",
  rx: 1.059
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 18.706,
  height: 2.118,
  x: 12.352,
  y: 31.412,
  fill: "#656565",
  rx: 1.059
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 13.059,
  height: 2.118,
  x: 12.352,
  y: 38.118,
  fill: "#656565",
  rx: 1.059
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#00B55E",
  d: "M7.316 27.883h-.003a1.33 1.33 0 0 1-1.072-.549l-1.117-1.538a.96.96 0 0 1 .21-1.34.955.955 0 0 1 1.337.21l.648.893 1.894-2.58a.955.955 0 0 1 1.338-.204.96.96 0 0 1 .203 1.341L8.387 27.34c-.25.34-.65.543-1.07.543M7.316 34.589h-.003a1.33 1.33 0 0 1-1.072-.549l-1.117-1.538a.96.96 0 0 1 .21-1.34.955.955 0 0 1 1.337.21l.648.893 1.894-2.58a.955.955 0 0 1 1.338-.204.96.96 0 0 1 .203 1.341l-2.367 3.224c-.25.34-.65.543-1.07.543M7.316 41.294h-.003a1.33 1.33 0 0 1-1.072-.548l-1.117-1.538a.96.96 0 0 1 .21-1.34.956.956 0 0 1 1.337.21l.648.892 1.894-2.58a.955.955 0 0 1 1.338-.203.96.96 0 0 1 .203 1.34l-2.367 3.224c-.25.34-.65.543-1.07.543"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 18.705,
  cy: 13.765,
  r: 7.059,
  fill: "#fff"
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "profileCVIco_svg__a",
  width: 15,
  height: 15,
  x: 11,
  y: 6,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 18.705,
  cy: 13.765,
  r: 7.059,
  fill: "#fff"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#profileCVIco_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M18.69 20.479a.74.74 0 1 0-.236-1.461.74.74 0 0 0 .237 1.46"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7E4F4D",
  d: "m22.576 18.574-2.288-1.054a.61.61 0 0 1-.355-.557v-1.54H17.13v1.54c0 .242-.14.457-.355.557l-2.288 1.054a1.84 1.84 0 0 0-1.064 1.785l.203 3.377a.61.61 0 0 0 .61.575h8.596a.61.61 0 0 0 .61-.575l.203-3.377c.044-.76-.38-1.47-1.068-1.785"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EB3737",
  d: "m22.576 18.574-1.74-.802a2.37 2.37 0 0 1-2.31 1.882 2.365 2.365 0 0 1-2.31-1.878l-1.736.798a1.84 1.84 0 0 0-1.065 1.785l.204 3.377a.61.61 0 0 0 .61.575h8.595a.61.61 0 0 0 .61-.575l.203-3.377a1.83 1.83 0 0 0-1.06-1.785"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#543736",
  d: "M17.129 17.027a3.36 3.36 0 0 0 2.808 0v-.817h-2.804z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M20.213 9.378a1.69 1.69 0 0 0-1.54-1.826 1.687 1.687 0 0 0-1.82 1.547 1.69 1.69 0 0 0 1.541 1.826 1.687 1.687 0 0 0 1.819-1.547"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M18.53 15.083c1.86 0 3.367-1.451 3.367-3.24s-1.507-3.24-3.366-3.24-3.367 1.45-3.367 3.24c0 1.789 1.507 3.24 3.367 3.24"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7E4F4D",
  d: "M21.73 12.84c-.023-.006-.163-.01-.163-.01a.56.56 0 0 1-.396-.164l-.243-.244a.56.56 0 0 0-.363-.164c-.547-.03-2.062-.167-3.263-.76a.28.28 0 0 0-.362.092 5.8 5.8 0 0 1-.924 1.091.56.56 0 0 1-.38.149h-.203a.4.4 0 0 0-.093.01c-.273.053-.458.316-.458.595v.204c0 .27.174.523.432.586q.089.022.17.015a.274.274 0 0 1 .288.23 2.81 2.81 0 0 0 2.757 2.308 2.81 2.81 0 0 0 2.757-2.308.277.277 0 0 1 .288-.23q.083.007.17-.015c.263-.063.433-.315.433-.586v-.256c.003-.267-.196-.46-.447-.542"
}))));
export default SvgProfileCvIco;